import config from "@/config";
import AssetHelper from "./asset.helper";
import OverlapHelper from "./overlap.helper";
import PointHelper from "./point.helper";
import PositionHelper from "./position.helper";
import UserHandler from "@/lib/SplashGame/UserHandler";
import Enemy from "@/prefabs/core/Enemy";
var rnd = function (min, max) {
    return Math.trunc(Math.random() * (max - min) + min);
};
var spawn_enemy = function (scene) {
    var user = UserHandler.getInstance().generate_user();
    var position = PositionHelper.run();
    var game = {
        score: 0,
        level: rnd(config.gameplay.enemy.level.min, config.gameplay.enemy.level.max),
        exp: 0,
        count_kill: 0,
        count_strike: 0,
        is_alive: true,
    };
    var newEnemy = new Enemy(scene, {
        id: user.id,
        username: user.username,
        type: 1,
        position: position,
        game: game,
    });
    OverlapHelper.overlap(scene, scene.player, newEnemy, scene.enemies);
    PointHelper.overlap(scene, newEnemy, function (enemy, point) {
        enemy.addExp(point.getValue().exp);
    });
    scene.enemies.push(newEnemy);
    AssetHelper.loadProfile(scene, user);
};
var init = function (scene) {
    scene.enemies = [];
    Array(config.gameplay.enemy.size)
        .fill(0)
        .forEach(function () { return spawn_enemy(scene); });
};
var EnemyHelper = { init: init };
export default EnemyHelper;
